import { setCurrentPageNo } from "pages/ArticlesApprovalManagement/articlesSlice";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TableDatePicker } from "themes/Icon";
// import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import EmptyState from "themes/elements/EmptyState";
import PaginationComp from "themes/elements/Pagination";
// import { isPermit } from "utils/permissionCheck";
import { DeleteIcon } from "themes/Icon";
import SearchComp from "themes/elements/Search";
import SelectComp from "themes/elements/Select";
import TagComp from "themes/elements/Tag";
import TooltipComp from "themes/elements/Tooltip";
import DatePickerComp from "../../DatePicker";
import "../table_comp.scss";

function ArticleApprovelTable({
  column,
  data,
  dataClick,
  approve = false,
  onDeleteAction,
  currentPageNo,
  totalPageNo,
  // handleEdit,
  setSelectedData = () => {},
  isLoading,
  // editAction,
  filterTitle,
  filterWard,
  filterCouncillor,
  filterTerm,
  filterReason,
  filterReqCouncillor,
  filterStatus,
  filterPublish,
  filterSubmit,
  filterAuthor,
  setFilterAuthor = () => {},
  setIsReject = () => {},
  setFilterSubmit = () => {},
  setIsApprove = () => {},
  setFilterStatus = () => {},
  setFilterReason = () => {},
  setFilterTerm = () => {},
  setFilterTitle = () => {},
  setFilterWard = () => {},
  setFilterCouncillor = () => {},
  setIsDetails = () => {},
  setFilterReqCouncillor = () => {},
  setFilterPublish = () => {},
  setDetails = () => {},
}) {
  const [currentPageData, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [publishDate, setPublishDate] = useState(null);
  const [submitDate, setSubmiteDate] = useState(null);
  useEffect(() => {
    setCurrentPageData(data);
    setSelectedData([]);
  }, [data]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPageNo(page));
  };

  function debounce(func, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const handleStatusChange = (value, item) => {
    dispatch(setCurrentPageNo(1));

    setFilterStatus(item);
  };

  const handleSearchChangeDebounced = useCallback(
    debounce((value, type) => {
      dispatch(setCurrentPageNo(1));
      if (type === "title") {
        setFilterTitle(value);
      } else if (type === "ward") {
        setFilterWard(value);
      } else if (type === "reason") {
        setFilterReason(value);
      } else if (type === "councilor") {
        setFilterCouncillor(value);
      } else if (type === "requester") {
        setFilterReqCouncillor(value);
      } else if (type === "author") {
        setFilterAuthor(value);
      }
    }, 30),
    []
  ); // 300 ms debounce time

  // This function is what gets called by the event listener
  const handleSearchChange = (event, type) => {
    const value = event.target.value;
    handleSearchChangeDebounced(value, type);
  };

  const SkeletonRow = ({ columns }) => (
    <tr className="table-row">
      {columns.map((col, index) => (
        <td key={index} className="table-data" style={{ width: col.width }}>
          <div className="skeleton-box"></div>
        </td>
      ))}
    </tr>
  );

  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const handlePublishDateChange = (dateString) => {
    dispatch(setCurrentPageNo(1));

    setPublishDate(dateString);
    if (dateString) {
      const formattedDate = formatDate(dateString);
      setFilterPublish(formattedDate);
    } else {
      setFilterPublish(null);
    }
  };

  const handleSubmitDateChange = (dateString) => {
    setSubmiteDate(dateString);
    dispatch(setCurrentPageNo(1));
    if (dateString) {
      const formattedDate = formatDate(dateString);
      setFilterSubmit(formattedDate);
    } else {
      setFilterSubmit(null);
    }
  };

  const clearFilters = () => {
    setFilterPublish();
    setFilterSubmit();
    setSubmiteDate(null);
    setFilterAuthor();
    setPublishDate(null);
    dispatch(setCurrentPageNo(1));
    setCurrentPageData(data);
    setFilterTitle("");
    setFilterWard("");
    setFilterTerm();
    setFilterCouncillor("");
    setFilterReason();
    setFilterReqCouncillor();
  };

  const onDataClick = (row) => {
    dataClick(row);
  };

  return (
    <div className="table-wrapper">
      <table className="table-comp">
        <thead className="table-head">
          <tr className="table-row">
            {column.map((col, i) => (
              <th
                className="table-header"
                key={i}
                style={{ minWidth: col.width }}
              >
                <span className="flex align-center gap-3">{col.title}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          <tr className="table-row">
            {column.map((col, i) => (
              <td className="table-data" style={{ width: col.width }} key={i}>
                {col.filter === "searchTitle" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterTitle}
                    onChange={(e) => handleSearchChange(e, "title")}
                  />
                ) : col.filter === "searchCouncillor" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterCouncillor}
                    onChange={(e) => handleSearchChange(e, "councilor")}
                  />
                ) : col.filter === "searchAuther" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterAuthor}
                    onChange={(e) => handleSearchChange(e, "author")}
                  />
                ) : col.filter === "searchNumber" ? (
                  <SearchComp
                    type="number"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterWard}
                    onChange={(e) => handleSearchChange(e, "ward")}
                  />
                ) : col.filter === "searchReason" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReason}
                    onChange={(e) => handleSearchChange(e, "reason")}
                  />
                ) : col.filter === "selectStatus" ? (
                  <SelectComp
                    allowClear={false}
                    value={filterStatus}
                    className="table-select"
                    placeholder={col.placeholder ? col.placeholder : col.title}
                    onChange={handleStatusChange}
                    data={col.dropDown.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    onClear={false}
                  />
                ) : col.filter === "searchRequsted" ? (
                  <SearchComp
                    type="text"
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterReqCouncillor}
                    onChange={(e) => handleSearchChange(e, "requester")}
                  />
                ) : col?.filter === "datePickerSubmit" ? (
                  <DatePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handleSubmitDateChange}
                    setValue={setSubmiteDate}
                    value={submitDate}
                  />
                ) : col.filter === "published_date" ? (
                  <DatePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handlePublishDateChange}
                    setValue={setPublishDate}
                    value={publishDate}
                  />
                ) : null}
              </td>
            ))}
          </tr>
          {(filterTitle ||
            filterAuthor ||
            filterReason ||
            filterWard ||
            filterCouncillor ||
            filterReqCouncillor ||
            filterPublish ||
            filterSubmit ||
            filterTerm) && (
            <div className="clr-btn-container">
              <ButtonComp height={16} variant="link" onClick={clearFilters}>
                Clear filters
              </ButtonComp>
            </div>
          )}
          {!isLoading ? (
            currentPageData?.length > 0 ? (
              currentPageData.map((row) => (
                <tr className="table-row" key={row?.id}>
                  {column.map((col, colIndex) => {
                    return (
                      <td
                        style={{ width: col.width }}
                        className="table-data"
                        key={colIndex}
                      >
                        {col.key === "councillor" && row[col.key] !== null ? (
                          <div className="flex align-center">
                            {row?.councilor_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <AvatarComp
                                size={32}
                                blue
                                src={row.councilor_image}
                              />
                            ) : (
                              <AvatarComp size={32} blue>
                                {row[col.key]?.replace(" ", "")[0]}
                              </AvatarComp>
                            )}
                            <span className="table-title ml-3">
                              {row[col.key]}
                            </span>
                          </div>
                        ) : col.key === "author" ? (
                          <div className="flex table-title align-center no_cursor">
                            {row?.created_user_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <div className="no_cursor">
                                <AvatarComp
                                  size={32}
                                  blue
                                  src={row.created_user_image}
                                />
                              </div>
                            ) : (
                              <div className="no_cursor ">
                                <AvatarComp size={32} blue>
                                  {row.created_user_name?.replace(" ", "")[0]}
                                </AvatarComp>
                              </div>
                            )}
                            <div>
                              <TooltipComp title={row.created_user_name}>
                                <span
                                  className=" ml-3 no_cursor ellipsis-text"
                                  onClick={() => {
                                    onDataClick(row);
                                  }}
                                >
                                  {row?.created_user_name}
                                </span>
                              </TooltipComp>
                            </div>
                          </div>
                        ) : col.key === "title" && row[col.key] !== null ? (
                          <div
                            onClick={() => {
                              onDataClick(row);
                              setDetails(true);
                            }}
                            className="flex align-center cursor-pointer"
                          >
                            {row?.images[0]?.project_image?.length > 0 &&
                            row[col.key] !== null ? (
                              <span className="councilor_image">
                                <AvatarComp
                                  shape="square"
                                  size={32}
                                  blue
                                  src={row?.images[0]?.project_image}
                                />
                              </span>
                            ) : (
                              <>
                                <span className="councilor_image ">
                                  <AvatarComp size={32} shape="square" blue>
                                    {row.title?.replace(" ", "")[0]}
                                  </AvatarComp>
                                </span>
                              </>
                            )}
                            <TooltipComp title={row.title}>
                              <span className=" align-center ml-3 limit-lines">
                                {row.title}
                              </span>
                            </TooltipComp>
                          </div>
                        ) : col.key === "created_user_name" &&
                          row[col.key] !== null ? (
                          <div
                            className={`flex align-center  ${
                              approve ? "approve" : ""
                            }`}
                          >
                            <div>
                              <div className="created_user_name no_cursor ">
                                {row?.councilor_image?.length > 0 &&
                                row.first_name ? (
                                  <AvatarComp
                                    size={32}
                                    blue
                                    src={row.councilor_image}
                                  />
                                ) : (
                                  <AvatarComp size={32} blue>
                                    {row?.first_name?.replace(" ", "")[0]}
                                  </AvatarComp>
                                )}

                                <span className="table-title ml-3 no_cursor">
                                  {row.first_name + " " + row.last_name}
                                </span>
                              </div>
                              {approve ? (
                                <div className="approve-container">
                                  <ButtonComp
                                    wFull
                                    variant="secondary"
                                    className="rejectBtn"
                                    onClick={() => {
                                      onDataClick(row);
                                      setIsReject(true);
                                    }}
                                    height={25}
                                  >
                                    Reject
                                  </ButtonComp>
                                  <ButtonComp
                                    onClick={() => {
                                      onDataClick(row);
                                      setIsApprove(true);
                                    }}
                                    variant="primary"
                                    wFull
                                    className="approveBtn"
                                    height={25}
                                  >
                                    Approve
                                  </ButtonComp>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ) : col.key === "status" ? (
                          <div>
                            <TagComp
                              className={
                                row?.project_status_flg === 2
                                  ? "ant-tag-green"
                                  : "ant-tag-red"
                              }
                            >
                              {row?.project_status_flg === 2
                                ? "Published"
                                : "Rejected"}
                            </TagComp>
                          </div>
                        ) : (
                          <span className="flex align-center gap-2 no_cursor ">
                            {row[col.key]}
                          </span>
                        )}
                        {!approve && (
                          <div className="action-container">
                            <ButtonComp
                              onClick={() => {
                                onDeleteAction(row);
                              }}
                              height={32}
                              rounded
                            >
                              <DeleteIcon />
                            </ButtonComp>
                          </div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <EmptyState />
            )
          ) : (
            Array(10)
              .fill(0)
              .map((_, index) => <SkeletonRow key={index} columns={column} />)
          )}
        </tbody>
      </table>

      <PaginationComp
        isLoading={isLoading}
        currentPageNo={currentPageNo}
        total={totalPageNo}
        onChange={handlePageChange}
      />
    </div>
  );
}

export default ArticleApprovelTable;
